import React from 'react'
import PropTypes from 'prop-types'

export default function MemoryMonitor(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
        fill={props.color || '#8E8E92'}
      />
      <path
        d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z"
        fill={props.color || '#8E8E92'}
      />
      <path
        d="M15 15H17V17H15V15Z"
        fill={props.color || '#8E8E92'}
      />
    </svg>
  )
}

MemoryMonitor.propTypes = {
  color: PropTypes.string
}
